import { Theme, Tooltip, withStyles } from '@material-ui/core';

export const LightTooltip = withStyles((theme: Theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[1],
        color: theme.palette.text.primary
    }
}))(Tooltip);
